'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductsService = function () {
  function ProductsService(Api) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ProductsService);
    this.api = Api;
  }

  (0, _createClass3.default)(ProductsService, [{
    key: 'loadAllProducts',
    value: function loadAllProducts() {
      return this.api.call({
        method: 'get',
        url: '/products'
      });
    }
  }, {
    key: 'loadProductMaterials',
    value: function loadProductMaterials(productId) {
      return this.api.call({
        method: 'get',
        url: '/products/' + productId + '/materials'
      });
    }
  }, {
    key: 'loadProductMaterialSpec',
    value: function loadProductMaterialSpec(productId, materialId) {
      var url = '/products/' + productId + '/materials/' + materialId + '/spec';
      return this.api.call({
        method: 'get',
        url: url
      });
    }
  }, {
    key: 'loadProductMaterialPricing',
    value: function loadProductMaterialPricing(productSlug, materialSlug) {
      var url = '/products/' + productSlug + '/materials/' + materialSlug + '/pricing_spec';
      return this.api.call({
        method: 'get',
        url: url
      });
    }
  }, {
    key: 'deleteProductMaterialShape',
    value: function deleteProductMaterialShape(productId, materialId, shapeId) {
      var url = '/products/' + productId + '/materials/' + materialId + '/shapes/' + shapeId;
      return this.api.call({
        method: 'delete',
        url: url
      });
    }
  }, {
    key: 'addProductMaterialShape',
    value: function addProductMaterialShape(productId, materialId, shapeId) {
      var url = '/products/' + productId + '/materials/' + materialId + '/shapes/' + shapeId;
      return this.api.call({
        method: 'post',
        url: url
      });
    }
  }, {
    key: 'deleteProductMaterialFixmethod',
    value: function deleteProductMaterialFixmethod(productId, materialId, fixmethodId) {
      var url = '/products/' + productId + '/materials/' + materialId + '/fixmethods/' + fixmethodId;
      return this.api.call({
        method: 'delete',
        url: url
      });
    }
  }, {
    key: 'addProductMaterialFixmethod',
    value: function addProductMaterialFixmethod(productId, materialId, fixmethodId) {
      var url = '/products/' + productId + '/materials/' + materialId + '/fixmethods/' + fixmethodId;
      return this.api.call({
        method: 'post',
        url: url
      });
    }
  }, {
    key: 'addProductMaterialColor',
    value: function addProductMaterialColor(productId, materialId, colorId) {
      var url = '/products/' + productId + '/materials/' + materialId + '/colors/' + colorId;
      return this.api.call({
        method: 'post',
        url: url
      });
    }
  }, {
    key: 'deleteProductMaterialColor',
    value: function deleteProductMaterialColor(productId, materialId, colorId) {
      var url = '/products/' + productId + '/materials/' + materialId + '/colors/' + colorId;
      return this.api.call({
        method: 'delete',
        url: url
      });
    }
  }, {
    key: 'saveProductMaterialPricing',
    value: function saveProductMaterialPricing(productSlug, materialSlug, spec) {
      var url = '/products/' + productSlug + '/materials/' + materialSlug + '/pricing_spec';
      return this.api.call({
        method: 'post',
        url: url,
        data: spec,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'updateName',
    value: function updateName(data, type) {
      var url = '/products/update_name/' + type;
      return this.api.call({
        method: 'put',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }]);
  return ProductsService;
}();

// WEBPACK FOOTER //


exports.default = ProductsService;


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/services/products.service.js
 **/